import styled from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScStepsByGroup = styled.div`
  margin-top: 40px;

  @media (${device.mobile}) {
    margin-top: 8px;
  }

  & > .cards {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 64px;
    margin-left: 48px;

    @media (${device.mobile}) {
      flex-direction: column;
      gap: 16px;
    }
  }
`;

export const ScStepsByGroupTitle = styled.h2`
  ${typography['headline2']}
  text-align: center;
  color: ${({ theme }) => theme.whiteColor};
  margin-bottom: 24px;
  text-transform: uppercase;

  @media (${device.mobile}) {
    ${typography['headline2mobile']}
  }
`;

export const ScStepsByGroupCard = styled.div`
  position: relative;
  width: 100%;
  padding: 24px 24px 24px 40px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.grayDarkColor};

  & > .image {
    position: absolute;
    top: 50%;
    left: -48px;
    transform: translateY(-50%);
    object-fit: none;
  }

  & > .title {
    ${typography['body1bold']}
    color: ${({ theme }) => theme.whiteColor};
  }

  & > .description {
    margin-top: 8px;
    ${typography['body1regular']}
    font-weight: 400;
    letter-spacing: 0em;
    color: ${({ theme }) => theme.manateeColor};
  }
  & > .label {
    position: absolute;
    bottom: 4px;
    right: 4px;

    display: flex;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
    border-radius: 20px;

    ${typography['caption2bold']}
    color: ${({ theme }) => theme.success};
    background: rgba(26, 178, 50, 0.2);
  }
`;
